import styled from 'styled-components';

export const Button = styled.button`
  display: flex;
  justify-content: center;
  cursor: pointer;
  transition:
    background-color 0.3s ease,
    transform 0.2s ease;
  text-align: center;

  &:disabled {
    background-color: #bebebe !important;
    border: 2px solid #858585;
    cursor: not-allowed !important;
  }
`;

export const AddButton = styled(Button)`
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  width: fit-content;
  border: 2px solid #29459c;
  background-color: #8aa0ed;
  font-size: 1.25em;
  font-weight: 500;
  cursor: pointer;
  margin: 1rem 0 3rem;
  border-radius: 8px;
`;

export const InfoButton = styled(Button)`
  text-align: center;
  padding: 0.625rem 1rem;
  width: fit-content;
  border: 2px solid #29459c;
  background-color: #8aa0ed;
  font-size: 1em;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
`;

export const ScoreButton = styled(Button)`
  border: 1px solid #b88925;
  background-color: #f3c666;
  padding: 0.675rem;
  font-weight: 500;
  font-size: 1.125rem;
  width: 100%;
  text-align: center;
  color: black;
  min-height: 2.875rem;

  img {
    width: 20px;
  }

  &:hover {
    background-color: #f0ba47;
  }

  @media (hover: none) {
    &:hover {
      background-color: inherit;
      transform: none;
    }
  }

  &:active {
    background-color: #f0ba47;
  }

  &:disabled {
    background-color: #bebebe !important;
    border: 2px solid #858585;
    cursor: not-allowed !important;
  }
`;

export const SubmitButton = styled.button`
  padding: 0.5rem 1rem;
  width: 100%;
  border: 2px solid #008e47;
  background-color: #00c679;
  color: white;
  font-size: 1.25em;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;

  &:disabled {
    background-color: #bebebe !important;
    border: 2px solid #858585;
    cursor: not-allowed !important;
  }
`;

export const DeleteButton = styled(Button)`
  height: 3.125rem;
  border-radius: 5px;
  border: 2px solid rgba(0, 0, 0, 0.3);
  background-color: #fb9b9b;
  cursor: pointer;
  align-items: center;
`;
